import { useLayoutEffect } from "react";

/**
 * A layout's own classes on <body>: added on mount, removed on unmount, so switching layouts
 * (sign-in → console → logout) never leaves one layout's background or offsets on the next.
 * ConsoleLayout does the same inline, alongside AdminLTE's initialize()/teardown().
 */
export const useBodyClasses = (...classes: string[]) => {
  const key = classes.join(" ");
  useLayoutEffect(() => {
    const list = key.split(" ").filter(Boolean);
    document.body.classList.add(...list);
    return () => document.body.classList.remove(...list);
  }, [key]);
};
